<template>
    <div class="detail-card">
        <div class="detail-card__item"  ref="map" v-for="(map, i) in $getGlobalData.maps" :id="map.id" >
            <img :src="map.image" alt="Woning selector kaart">
            <svg viewBox="0 0 1000 1000">
                <g>
                    <polygoon
                            v-for="(points, ii) in $getGlobalData.maps[map.sort_order].pointers"
                            :polygonpoints="points.coordinates"
                            :eyemoveid="points.eyemove_id"
                            :mapid="points.map_id"
                            :key="ii"
                            :index="ii"
                            :order="map.sort_order"
                            v-if="points.eyemove_id === houseId"

                    ></polygoon>
                </g>
            </svg>
        </div>
    </div>
</template>

<script>

    import Polygoon from '../components/Polygoon.vue';

    export default {
        props:{
            houseid:{
                type: Number
            }
        },
        components: {
            Polygoon
        },
        data() {
            return {
                houseId: '',
                inMap: ''
            }
        },
        mounted(){
            this.houseId = this.houseid
        },
        methods: {
            activePolygon (e, o){
                this.inMap = e;

                if(this.$refs.map[o].id === this.inMap){
                    this.$refs.map[o].classList.add('active')
                }
            }
        }
    }
</script>
